import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-empty',
  templateUrl: './table-empty.component.html',
  styleUrls: ['./table-empty.component.scss'],
})
export class TableEmptyComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
